import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import Landing from './pages/Landing';
import Subscribe from './pages/Subscribe';
import Paid from './pages/Paid';
import Card from './pages/Card';
import ShopScreen from './pages/ShopScreen';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import Print from './pages/Print';
import Me from './pages/Me';
import Invoice from './pages/Invoice';
import Start from './pages/Start';
import StartDone from './pages/StartDone';

const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  { path: '/s/:slug', element: <Subscribe /> },
  { path: '/s/:slug/paid', element: <Paid /> },
  { path: '/card/:token', element: <Card /> },
  { path: '/shop/:slug', element: <ShopScreen /> },
  { path: '/shop', element: <ShopScreen /> },
  { path: '/admin', element: <Admin /> },
  { path: '/pay/:id', element: <Invoice /> },
  { path: '/start', element: <Start /> },
  { path: '/start/done', element: <StartDone /> },
  { path: '/print/:slug', element: <Print /> },
  { path: '/me', element: <Me /> },
  { path: '*', element: <NotFound /> },
]);

if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(() => {});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
